module.exports = __webpack_public_path__ + "static/LytePop-logo-wg-dfc6150248bcf080ca292eb1d8cce5c4.png";